(function () {
  // Poll briefly for the swiper bundle, then give up rather than spin forever.
  function waitForSwiper(cb) {
    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      if (typeof Swiper !== 'undefined') {
        clearInterval(timer);
        cb();
      } else if (tries > 100) {
        clearInterval(timer);
      }
    }, 50);
  }

  function initSection(root) {
    var tabs = root.querySelectorAll('[data-hygloss-tab]');
    var panels = root.querySelectorAll('[data-hygloss-panel]');
    var swipers = {};

    function initSwiper(panel) {
      var el = panel.querySelector('.swiper');
      if (!el || el.dataset.hyglossInit === 'true') return;
      // swiper-bundle is loaded independently of this file, so it may not be on
      // window yet. Bailing out here used to leave the rail as one full-width
      // slide, so wait for it instead of giving up.
      if (typeof Swiper === 'undefined') {
        waitForSwiper(function () {
          initSwiper(panel);
        });
        return;
      }
      el.dataset.hyglossInit = 'true';
      var instance = new Swiper(el, {
        // Figma mobile (1:2708): 296.39px cards on a 308.39px pitch in 390.
        slidesPerView: 1.3035,
        spaceBetween: 12,
        watchOverflow: true,
        navigation: {
          nextEl: panel.querySelector('.hygloss-nav-btn--next'),
          prevEl: panel.querySelector('.hygloss-nav-btn--prev')
        },
        pagination: {
          el: panel.querySelector('.swiper-pagination'),
          clickable: true
        },
        breakpoints: {
          540: { slidesPerView: 2.2, spaceBetween: 20 },
          750: { slidesPerView: 3.2, spaceBetween: 20 },
          // Figma desktop (1:2066): 369px cards on a 389px pitch in 1536, and it
          // shows 2 dots for 8 products - the pagination counts full pages, not
          // slides, so the group must match the view.
          1000: { slidesPerView: 4, slidesPerGroup: 4, spaceBetween: 20 }
        }
      });
      swipers[panel.dataset.hyglossPanel] = instance;
    }

    panels.forEach(function (panel) {
      if (!panel.hidden) initSwiper(panel);
    });

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = tab.getAttribute('data-hygloss-tab');
        tabs.forEach(function (t) {
          var active = t === tab;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        panels.forEach(function (panel) {
          var match = panel.dataset.hyglossPanel === target;
          panel.hidden = !match;
          if (match) {
            initSwiper(panel);
            if (swipers[target]) swipers[target].update();
          }
        });
      });
    });

    // Add to cart is intentionally NOT handled here. The markup uses the theme's
    // <product-form> and <quick-add-drawer-opener> custom elements (product-form.js /
    // quick-add.js), which own the AJAX cart, cart drawer, cart count, loading and
    // error states. Do not re-add cart logic to this file.
  }

  document.querySelectorAll('[data-hygloss-bestsellers]').forEach(initSection);
})();
